import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import IAddress from "../core/interfaces/IAddress";
import findLocationRequest from "../core/api/requests/utils/findLocationRequest.ts";
import { KTSVG } from "../../_metronic/helpers/index.ts";
import {
    APIProvider,
    Map,
    InfoWindow,
    Marker, 
    AdvancedMarker,
    ControlPosition,
    MapControl,
    Pin
  } from '@vis.gl/react-google-maps';
import {Simulate} from "react-dom/test-utils";
import input = Simulate.input;

export interface IComponent {
    hideLabel?: boolean;
    fieldsProps?: any;
    i18n: string;
    error?: string;
    value?: string;
    touched?: boolean;
    type?: string;
    disabled?: boolean;
    inputGroup?: any[];
    inputClassName?: string;
    onChange?:(option: IAddress) => void
}

export default function(props:IComponent){
    const intl = useIntl()
    const dispatch = useDispatch()

    const [ results, setResults ] = useState<IAddress[]>([])
    const [ query, setQuery ] = useState<string>('')
    const [ selected, setSelected ] = useState<IAddress | null>(null)
    const [ TO, setTO ] = useState<any>(null)
    const [showMap,  setShowMap] = useState<boolean>(false)

    const findLocation = async () => {
        if (!query) {
            setResults([])
            return
        }

        const response = await findLocationRequest(dispatch, query)

        if (response.data) {
            setResults(response.data)
        }
    }
    const onSelect = (value:IAddress) => {
        setQuery('')
        setResults([])
        setSelected(value)
    
        if (props.onChange) {
          props.onChange(value)
        }
    }
    const fetchSelectedLocation = async () => {
        if (props.value && !selected) {
            const response = await findLocationRequest(dispatch, props.value); 

            if (response.data && response.data.length > 0) {
                const location = response.data.find((item: IAddress) => item.fullAddress === props.value);
                if (location) {
                    setSelected(location); 
                }
            }
        }
    };

    const handleShowMap = async () => {
        if (!selected ) {
            await fetchSelectedLocation(); 
        }
        setShowMap(!showMap);  
    };
    useEffect(() => {
        if (TO) {
          clearTimeout(TO)
        }
    
        setTO(setTimeout(() => {
          findLocation()
        }, 500))
      }, [query]);

    return <>
        {!props.hideLabel &&
            <label className="fs-6 fw-semibold mb-2">{intl.formatMessage({id: props.i18n})}</label>
        }
        <div
            className={'w-100 rounded leaflet-container leaflet-touch leaflet-fade-anim leaflet-grab leaflet-touch-drag leaflet-touch-zoom'}>
            <div className={'input-group'}>
                <span className={'input-group-text border-0'}>
                    <i className="ki-duotone ki-geolocation fs-2">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    </i>
                </span>
                <input
                    type="text"
                    className="form-control form-control-lg form-control-solid"
                    name="search"
                    onChange={(e) => setQuery(e.target.value)}
                    value={query || props.value}
                    placeholder={intl.formatMessage({id: props.i18n})}
                    autoComplete="off"
                    {...props.fieldsProps}
                />
                {(selected || props.value) && 
                    <span className={'input-group-text border-0'}>
                        <span 
                            className="svg-icon svg-icon-warning me-4 mb-6 mb-sm-0"                    
                            onClick={() => handleShowMap()}
                        >
                            <KTSVG path="media/icons/duotune/maps/map002.svg" />
                        </span>
                    </span>                
                }
            </div>

            {(results.length > 0 && query !== '') &&
                <div className={'position-relative ms-14'}>
                    <div className={'menu menu-sub menu-sub-dropdown py-2 w-325px w-md-500px show position-absolute'}>
                        <div className={'scroll-y mh-200px mh-lg-325px'}>
                        {results.map((r) => {
                            return <div
                            onClick={() => {
                                onSelect(r)
                            }}
                            className={'d-flex align-items-center py-2 px-5 bg-hover-light'} key={r.fullAddress}
                            >
                                <div className="symbol symbol-40px me-4">
                                    <span className="svg-icon svg-icon-2x svg-icon-warning me-4 mb-6 mb-sm-0">
                                        <KTSVG path="media/icons/duotune/general/gen018.svg" />
                                    </span>
                                </div>
                                <div className="d-flex flex-column">
                                    <a href="#" className="fs-6 text-gray-800 text-hover-primary fw-semibold">{r.fullAddress}</a>
                                    <span className="fs-7 text-muted fw-semibold">{`${r.city ? r.city+', ' : ''}${r.province ? r.province+', ' : ''}${r.country}`}</span>
                                </div>
                            </div>
                        })
                        }
                        </div>
                    </div>
                </div>
            }

            {(props.touched && props.error) && (
                <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                    <span role='alert'>{props.error}</span>
                    </div>
                </div>
            )}

            {(selected && showMap) &&
            <div className={'w-100 h-250px mt-3'}>
                <APIProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''}>
                <Map
                    style={{width: '100%', height: '100%'}}
                    defaultCenter={{
                    lat: selected.latitude,
                    lng: selected.longitude,
                    }}
                    defaultZoom={11}
                    gestureHandling={'greedy'}
                    disableDefaultUI={true}
                >
                    <Marker position={{
                    lat: selected.latitude,
                    lng: selected.longitude,
                    }}></Marker>

                    {/* <InfoWindow
                    pixelOffset={[0, -40]}
                    minWidth={200}
                    position={{
                        lat: selected.latitude,
                        lng: selected.longitude,
                    }}
                    >
                    <div className={'pe-3'}>
                        <p><strong>{selected.fullAddress}</strong></p>
                        <p>{selected.postalCode} - {selected.city}</p>
                        <p>{selected.province} - {selected.country}</p>
                    </div>
                    </InfoWindow> */}
                </Map>
                </APIProvider>

            </div>
            }
        </div>
    </>    
}